import { TemplateItem as StoreTemplateItem } from '@anm/api/modules/templates';
import VirtualItem from '@anm/components/list/VirtualList/VirtualItem';
import isMobile from '@anm/helpers/is/isMobile';
import usePageParams from '@anm/hooks/usePageParams';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { filterSelectors } from '../../../store/modules/filter';
import { selectSmallSize } from '../../../store/modules/template/selectors';
import VideoBlockWrapper from '../VideoBlock';

import { getMediaByAspects, getTemplateLink } from './helpers';

export type TemplateItemProps = StoreTemplateItem & {
  height?: number;
  // isFirstRenderPreview?: boolean;
};

export const MASONRY_ITEM_MARGIN_BOTTOM = 40;

const TemplateItem: FC<TemplateItemProps> = ({
  slug,
  meta,
  templateId,
  displayName
  // isFirstRenderPreview
}) => {
  const pageParams = usePageParams();
  const templateFilters = useSelector(filterSelectors.selectTemplatesFilters);

  const { price, media, duration, defaultTarget } = meta;
  const templateName = slug ? slug : `${templateId}_${displayName}`;
  const templateAspects = templateFilters.aspects;

  const currentMedia = (templateAspects && getMediaByAspects(templateAspects, media)) || media[defaultTarget];

  const { size, url: preview } = selectSmallSize(currentMedia.thumb);
  const { url: videoUrl } = selectSmallSize(currentMedia.video);

  const link = getTemplateLink({
    pageParams,
    templateName,
    filters: templateFilters
  });

  const isImage = meta.kind === 'image';

  return (
    <VirtualItem>
      <VideoBlockWrapper
        {...{
          slug,
          size,
          link,
          preview,
          displayName,
          templateId,
          // isFirstRenderPreview,
          ...(!isImage && { duration }),
          ...(!isMobile() && !isImage && { videoUrl })
        }}
        isPremium={price > 0}
      />
    </VirtualItem>
  );
};

export default TemplateItem;
